import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'oidc-react'

import { Spinner } from 'Shared/atoms'
import { AuthFields } from 'Shared/utils/auth'

import { BASIC_ROOT_ROUTE } from 'Core/constants'
import { INITIAL_PAGE_NAME } from 'Core/utils/applicationinsights/constants'
import TelemetryProvider from 'Core/utils/applicationinsights/TelemetryProvider'
import { getAppInsights } from 'Core/utils/applicationinsights/TelemetryService'

import { ApplicationInsightsProps } from './types'

const ApplicationInsights: React.FC<ApplicationInsightsProps> = ({ children, history }) => {
	const auth = useAuth()

	const [newLocations, setNewLocation] = useState<string>()
	const appInsights = getAppInsights()

	const location = useLocation()
	const userName =
		auth?.userData && AuthFields.impersonatorEmail in auth.userData.profile
			? `admin_${auth.userData.profile[AuthFields.impersonatorEmail]}_as_user_${
					auth.userData.profile[AuthFields.userEmailAddress]
			  }`
			: auth.userData?.profile[AuthFields.userEmailAddress]

	useEffect(() => {
		if (appInsights && newLocations !== location.pathname) {
			const pathname =
				location.pathname === BASIC_ROOT_ROUTE ? INITIAL_PAGE_NAME : location.pathname
			appInsights.trackPageView({
				name: pathname
			})
			setNewLocation(location.pathname)
			if (auth?.userData && AuthFields.impersonatorEmail in auth.userData.profile) {
				appInsights.setAuthenticatedUserContext(userName as string)
			}
		}
	}, [appInsights, location, newLocations, auth.userData, userName])

	if (!auth?.userData) {
		return <Spinner isFullWindow isBrandLogo />
	}

	return (
		<TelemetryProvider
			history={history}
			instrumentationKey={
				auth.userData.profile[AuthFields.appInsightsConnectionString] as string
			}
			userName={userName as string}
		>
			{children}
		</TelemetryProvider>
	)
}

export default ApplicationInsights
